<template>
<b-container class="bv-example-row">
    <Header></Header>
    <b-row>
      <b-col cols="12" class="hr"></b-col>
    </b-row>
    <b-row>
        <b-col cols="3">
          <Menu></Menu>
        </b-col>
        <b-col cols="9" class="border">
          <b-row>
            <b-col cols="12">
              <b-row>
                <b-col cols="12" class="head">
                  <h4>:: Versiones de {{this.$route.params.model}}</h4>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" class="breadcrumb">
                  <b-link :to="{ name: 'VersionesByModel' }">Versiones por Modelo</b-link> &raquo; <b-link :href="'/models-by-brand/model/'+this.$route.params.slug">Lista de Modelos de {{ this.version.brand }}</b-link>
                </b-col>
              </b-row>
              <div class="mt-2"></div>
              <b-form @submit="onSubmit">
                <b-form-group id="fieldsetHorizontal"
                          horizontal
                          :label-cols="4"
                          breakpoint="md"
                          label="Nombre">
                  <b-form-input id="name" :state="state" v-model.trim="version.name"></b-form-input>
                </b-form-group>
                <b-form-group id="fieldsetHorizontal"
                          horizontal
                          :label-cols="4"
                          breakpoint="md"
                          label="Slug de la Versión">
                  <b-form-input id="name" :state="state" v-model.trim="version.slug"></b-form-input>
                </b-form-group>
                <b-form-group id="fieldsetHorizontal"
                          horizontal
                          :label-cols="4"
                          breakpoint="md"
                          label="Código SAP">
                    <b-form-input id="department" :state="state" v-model.trim="version.codigo_sap"></b-form-input>
                </b-form-group>
                <b-button type="submit" variant="primary derco">Guardar</b-button>
              </b-form>
            </b-col>
          </b-row>
        </b-col>
    </b-row>
  </b-container>
</template>

<script>
/*eslint-disable */
import axios from "axios";
import Header from './Header'
import Menu from './Menu'
String.prototype.strip = function() {
  var translate_re = /[öäüÖÄÜßËë ]/g;
  var translate = {
    "ä":"a", "ö":"o", "ü":"u", "Ë":"e", "Ë":"e",
    "Ä":"A", "Ö":"O", "Ü":"U",
    " ":"-", "ß":"ss"  
  };
    return (this.replace(translate_re, function(match){
        return translate[match];})
    );
};
export default {
  name: "CreateVersion",
  components:{
    Header,
    Menu
  },
  data() {
    return {
      version: {
        model: null,
        model_id:null,
        brand: null,
        slug_brand: null,
        status: 1
      },
      brand: {}
    }
  },
  created(){
    if(localStorage.getItem('role')=="Administrador"){
      axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
      axios.get(`/brand/slug/` + this.$route.params.slug)
      .then(response => {
        this.brand = response.data
        document.title = "Administración Derco - Brand " + response.data[0].name
        this.version.brand = response.data[0].name
        this.version.slug_brand = response.data[0].slug
        this.version.model_id = this.$route.params.model_id
        this.version.model = this.$route.params.model
        console.log(this.version);
      })
      .catch(e => {
        this.errors.push(e)
        if(e.response.status === 401) {
          this.$router.push({
            name: 'Login'
          })
        }
      })
    }else{
      this.$router.push({
        name: 'Login'
      })
    }
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
      axios
        .post(`/version`, this.version)
        .then(response => {
          this.$router.push({
            name: "ShowVersion",
            params: { id: response.data._id, slug: this.$route.params.slug }
          })
        })
        .catch(e => {
          this.errors.push(e);
        })
    },
    logout () {
      localStorage.removeItem('jwtToken')
      this.$router.push({
        name: 'Login'
      })
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/CreateVersion.vue